<template>
  <!-- 表示テンプレート登録画面 -->
  <div id="PDashboardDisplayTemplateRegisterModal">
    <div class="modal-card" style="width: 440px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">表示テンプレート登録</p>
      </header>
      <section class="modal-card-body">
        <fieldset class="radio-row-style" :disabled="isDefaultTemplate">
          <b-radio class="td_radio" v-model.number="selectedRegisterValue" native-value="0">上書き保存</b-radio>
          <input type="text" placeholder="表示テンプレート名" v-model="templateNameUpdate" :disabled="isRegisterTemplate" maxlength="30">
        </fieldset>
        <fieldset class="radio-row-style">
          <b-radio class="td_radio" v-model.number="selectedRegisterValue" native-value="1">新規登録</b-radio>
          <input type="text" placeholder="表示テンプレート名" v-model="templateNameRegister" :disabled="!isRegisterTemplate" maxlength="30">
        </fieldset>
      </section>
      <footer class="modal-card-foot">
        <b-button class="is-primary" type="button" @click="register()" :disabled="roleId == role.role_salesOffice">保存</b-button>
        <b-button class="is-primary" type="button" @click="$parent.close()" >キャンセル</b-button>
      </footer>
    </div>
  </div>
</template>
<script>
import { role } from "@/components/mock/base/const.js";
const UNEXPECTED_ERROR = "予期しないエラーが発生しました。";

export default {
  name: "PDashboardDisplayTemplateRegisterModal",
  props: {
    displayTemplateList: Array,
    displayTemplate: Object,
    defaultSortField: null,
    defaultSortDirection: null,
  },
  data() {
    let userInfo = this.getUserInfo();
    return {
      role: role,                       // 選択肢マスタの定数
      roleId: userInfo.roleId,          // ロールID
      selectedRegisterValue: null,      // 保存方法 0: 上書き保存, 1: 新規登録
      isRegisterTemplate: null,         // ラジオボタンが新規登録の場合true, 上書き保存の場合false
      templateNameUpdate: null,         // 上書き保存の表示テンプレート名
      templateNameRegister: null,       // 新規登録の表示テンプレート名
      isDefaultTemplate: false,         // 上書き項目非活性用
    }
  },
  methods: {
    register: function() {
      // 表示テンプレート名が入力されているかをチェック
      let displayTemplateName = null;
      if (this.isRegisterTemplate) {
        // 新規登録
        displayTemplateName = this.templateNameRegister;
      } else {
        // 上書き保存
        displayTemplateName = this.templateNameUpdate;
      }
      if (!displayTemplateName) {
        // 入力欄が空いている場合
        this.showErrorMessage("表示テンプレート名を入力してください。");
        return;
      }

      // 表示テンプレート名が他の表示テンプレート名と重複している場合はメッセージを表示して処理を終了
      for (const template of this.displayTemplateList) {
        if (this.isRegisterTemplate) {
          // 新規登録
          if (displayTemplateName == template.templateName) {
            // 既に登録されている名前の入力
            this.showErrorMessage("この表示テンプレート名は既に登録されています。");
            return
          }
        } else {
          // 上書き保存
          if (this.displayTemplate.id !== template.id && displayTemplateName == template.templateName) {
            // 現在選択されているテンプレート以外のテンプレートかつ、既に登録されている名前の入力
            this.showErrorMessage("この表示テンプレート名は既に登録されています。");
            return
          }
        }
      }
      let _this = this;
      this.$dialog.confirm({
        title: "　",
        message: "表示テンプレートを保存します。<br/>よろしいでしょうか？",
        confirmText: "OK",
        cancelText: "キャンセル",
        onConfirm: async() => {
          // 表示テンプレートをデータベースに反映
          this.apiCall(
            function(client) {
              return client.apis.externalPDashboard.registerDisplayTemplatePOST({
                body:{
                  displayTemplate: _this.displayTemplate,
                  isRegisterTemplate: _this.isRegisterTemplate ? true : false,  // integer => boolean
                  displayTemplateName: displayTemplateName,
                  defaultSortField: _this.defaultSortField,
                  defaultSortDirection: _this.defaultSortDirection
                }
              });
            },
            function(result) {
              if (result && result.status == 200) {
                // 登録または更新完了のメッセージ
                let message = "登録が完了しました。";
                _this.showMessage(message, () => {
                  _this.$emit("backDisplayTemplateRegister", result.body.displayTemplateList, result.body.displayTemplateId);
                  _this.$parent.close();
                });
              } else {
                // エラーメッセージ表示
                _this.showErrorMessage(UNEXPECTED_ERROR);
              }
            },
            function(result){
              // エラーメッセージ表示
              _this.showErrorMessage(result);
            }
          );
        },
      });
    }
  },
  mounted(){
    // 表示テンプレートがデフォルトのものか登録済みのものかを判断
    if (this.displayTemplate.id == 0) {
      // デフォルトの表示テンプレートの場合
      this.selectedRegisterValue = 1;
      this.templateNameUpdate = null;
      this.templateNameRegister = null;
      // 上書き保存の項目を非活性
      this.isDefaultTemplate = true;
    } else {
      // 登録済みの表示テンプレートの場合
      this.selectedRegisterValue = 0;
      this.templateNameUpdate = this.displayTemplate.templateName;
      this.templateNameRegister = null;
    }
  },
  watch: {
    // 選択されたラジオボタンのvalueによってisRegisterTemplateにbooleanの値をセット、true : 新規登録, false : 上書き保存
    selectedRegisterValue(value) {
      this.isRegisterTemplate = value == 1 ? true : false;
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-card-body > .b-radio {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0px;
}
.modal-card-body span {
  font-size: 18px;
  margin-left: 5px;
  margin-right: 5px;
}
.radio-row-style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px auto;
}
.radio-row-style input {
  height: 32px;
  width: 250px;
  font-size: 18px;
}
.modal-card-foot {
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/patientdashboard/PDashboardDisplayTemplateRegisterModal.vue